module.exports = "<div class=\"card news news-card news-card-short news-type-{{::vm.news.type}}\"> <div class=card-bd> <div class=meta> <span class=date>{{::vm.news.date}}</span> <span class=badge>{{ ::vm.news.typeDescription }}</span> </div> <p class=title><a ng-href=\"{{::vm.news.url}}\">{{::vm.news.title}}</a></p> <p class=seller>&copy; {{::vm.news.sellerName}}</p> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/news/components/news-tile-short.html
// module id = 608
// module chunks = 0